export default {
    roles: {
        admin: 1,
        editor: 2,
        user: 3
    }
};
